import { render, staticRenderFns } from "./v-navbar-logo.vue?vue&type=template&id=4960dec8&scoped=true&"
import script from "./v-navbar-logo.vue?vue&type=script&lang=js&"
export * from "./v-navbar-logo.vue?vue&type=script&lang=js&"
import style0 from "./v-navbar-logo.vue?vue&type=style&index=0&id=4960dec8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960dec8",
  null
  
)

export default component.exports